export const PavilionVDNX_ru = {
    title: 'ВДНХ',
    head: 'Павильон',
    head_text: 'Выставка достижений народного хозяйства Российской Федерации',
    text:'Выставка достижений народного хозяйства — уникальное пространство музейно-выставочных проектов, международных деловых выставок.',
    textBtn: 'Перейти в павильон',
    allPavilion: 'Все 5 павильонов',
}